import {Action, ActionReducerMap} from '@ngrx/store';
import * as actionsUi from './aufgaben-berechtigungen-home.actions.ui';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {GET_FUNKTIONSBEREICHE, GET_FUNKTIONSBEREICHE_ERFOLGREICH, GET_FUNKTIONSBEREICHE_FEHLER, GetFunktionsbereicheErfolgreichAction} from '../../../../client-ngrx/vorlagen';
import {Funktionsbereich} from '../../../../clients/vorlagen';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    funktionsbereiche: Array<Funktionsbereich>;
    funktionsbereicheFehler: boolean;
    funktionsbereicheLaden: boolean;
}

export const initialPageState: PageState = {
    funktionsbereiche: [],
    funktionsbereicheFehler: false,
    funktionsbereicheLaden: false
};


export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // PAGE STATE RESET
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState, <PageState> {
            });
        }

        // Badges-Daten lesen
        case GET_FUNKTIONSBEREICHE: {
            return Object.assign({}, state, <PageState> {
                funktionsbereicheLaden: true,
                funktionsbereicheFehler: false
            });
        }

        case GET_FUNKTIONSBEREICHE_ERFOLGREICH: {
            const a = <GetFunktionsbereicheErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                funktionsbereicheLaden: false,
                funktionsbereicheFehler: false,
                funktionsbereiche: a.payload
            });
        }

        case GET_FUNKTIONSBEREICHE_FEHLER: {
            return Object.assign({}, state, <PageState> {
                funktionsbereicheLaden: false,
                funktionsbereicheFehler: true,
                funktionsbereiche: []
            });
        }

        default: {
            return state;
        }
    }
}
